
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
XTable,
FlexboxItem
},
props: {
except: String
},
methods: {
GoHS (name) {
this.$router.push({name: name, query: this.$route.query})
}
},
mounted () {
let btns = [
{
name: 'IMGoodsInfoHSDetail', title: '进口税则'
},
{
name: 'OMGoodsInfoHSDetail', title: '出口税则'
},
{
name: 'ImportLinkageTax_HSDetail', title: '代征税'
},
{
name: 'ExportRebates_HSDetail', title: '出口退税'
},












{
name: 'CiqSearchListByHS', title: 'CIQ编码'
}
]
let self = this
btns.reverse().forEach(function (item) {
if (item.name !== self.except) {
console.log(item.name)
self.buttons.push(item)
}
})
},
data () {
return {
buttons: []
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/HSBottom.vue